import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAllMembershipStatsForAudience as GetAllMembershipStatsForAudienceQuery,
    GetAllMembershipStatsForAudienceVariables,
    EmailMembershipStatsFragment as EmailMembershipStats,
    SmsMembershipStatsFragment as SmsMembershipStats,
} from 'nutshell-graphql-types';

import GET_ALL_MEMBERSHIP_STATS_FOR_AUDIENCE from '../queries/get-all-membership-stats-for-audience.graphql';

export const useGetAllMembershipStatsForAudience = (
    audienceId: string,
    isMcfx: boolean
): {
    emailMembershipStats: EmailMembershipStats | null | undefined;
    smsMembershipStats: SmsMembershipStats | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAllMembershipStatsForAudienceQuery,
        GetAllMembershipStatsForAudienceVariables
    >(GET_ALL_MEMBERSHIP_STATS_FOR_AUDIENCE, {
        variables: {
            audienceId,
        },
        skip: isMcfx,
    });

    const audience = data ? data.audience : null;

    return {
        emailMembershipStats: audience?.membershipStats,
        smsMembershipStats: audience?.smsMembershipStats,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
